(function () {
  const AUTO_SLIDE_DELAY = 1000;

  function parseImages(productCard) {
    try {
      return JSON.parse(productCard.dataset.images || "[]").filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  function initProductBoxSlider(productCard) {
    if (!productCard || productCard.dataset.productBoxSliderInit === "true") return;

    const mainImage = productCard.querySelector(".product-main-image img");
    const leftArrow = productCard.querySelector(".left-arrow");
    const rightArrow = productCard.querySelector(".right-arrow");
    const allImages = parseImages(productCard);

    if (!mainImage || allImages.length <= 1) return;

    productCard.dataset.productBoxSliderInit = "true";
s
    if (mainImage.hasAttribute("srcset")) {
      mainImage.removeAttribute("srcset");
      mainImage.removeAttribute("sizes");
    }

    if (!mainImage.dataset.src && allImages[0]) {
      mainImage.dataset.src = allImages[0];
    }

    let currentIndex = 0;
    let hoverInterval = null;
    let pointerInside = false;

    function updateImage(index) {
      if (!allImages[index]) return;
      mainImage.src = allImages[index];
      mainImage.dataset.src = allImages[index];
      currentIndex = index;
    }

    function stopAutoSlide(resetToDefault) {
      clearInterval(hoverInterval);
      hoverInterval = null;

      if (resetToDefault) {
        updateImage(0);
      }
    }

    function startAutoSlide(playImmediately) {
      stopAutoSlide(false);

      if (playImmediately) {
        currentIndex = (currentIndex + 1) % allImages.length;
        updateImage(currentIndex);
      }

      hoverInterval = setInterval(function () {
        currentIndex = (currentIndex + 1) % allImages.length;
        updateImage(currentIndex);
      }, AUTO_SLIDE_DELAY);
    }

    function stepSlide(direction) {
      stopAutoSlide(false);
      currentIndex = (currentIndex + direction + allImages.length) % allImages.length;
      updateImage(currentIndex);

      if (pointerInside) {
        startAutoSlide(false);
      }
    }

    productCard.addEventListener("mouseenter", function () {
      pointerInside = true;
      startAutoSlide(true);
    });

    productCard.addEventListener("mouseleave", function () {
      pointerInside = false;
      stopAutoSlide(true);
    });

    if (leftArrow) {
      leftArrow.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        stepSlide(-1);
      });
    }

    if (rightArrow) {
      rightArrow.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        stepSlide(1);
      });
    }
  }

  function initAllProductBoxSliders(root) {
    const scope = root || document;

    if (scope.nodeType === 1 && scope.matches && scope.matches(".product-box")) {
      initProductBoxSlider(scope);
    }

    if (scope.querySelectorAll) {
      scope.querySelectorAll(".product-box").forEach(initProductBoxSlider);
    }
  }

  function observeProductBoxChanges() {
    if (!window.MutationObserver || !document.body) return;

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          initAllProductBoxSliders(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  function boot() {
    initAllProductBoxSliders(document);
    observeProductBoxChanges();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  window.initAllProductBoxSliders = initAllProductBoxSliders;
})();
